import { render } from "./ProblemCard.vue?vue&type=template&id=4f71ee38"
import script from "./ProblemCard.vue?vue&type=script&lang=js"
export * from "./ProblemCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bip/bip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__